export const FUN_MESSAGES = {
  copy: [
    "📋 Copied! Paste away!",
    "✨ Magic copy complete!",
    "🚀 Copied faster than light!",
    "🎯 Got it! It's in your clipboard!",
    "🎨 Consider it copied, artistically!",
  ],
  update: {
    success: [
      "🎉 Another hotel perfectly updated!",
      "🌟 Changes saved with style!",
      "🏨 Hotel info is now fresh and fancy!",
      "✨ Changes saved faster than room service!",
      "🎨 Your changes are now live and lovely!"
    ],
    error: [
      "🤔 Oops! That didn't work as planned...",
      "📝 Let's try that update again, shall we?",
      "🎯 Almost there! But not quite...",
      "🔄 Time for another attempt!",
      "🎨 This canvas needs another stroke..."
    ]
  },
  theme: {
    dark: [
      "🌙 Welcome to the dark side!",
      "🌚 Night mode activated!",
      "✨ Stars are out, lights are down!"
    ],
    light: [
      "☀️ Let there be light!",
      "🌞 Bringing in the sunshine!",
      "✨ Brightening up your day!"
    ]
  },
  search: {
    noResults: [
      "🔍 Hmm... This hotel is playing hide and seek!",
      "🎯 Not quite what we're looking for...",
      "🌟 Let's try another search adventure!",
      "✨ Time to explore different terms!",
      "🏨 No hotels found in this dimension..."
    ],
    tooMany: [
      "🎉 Wow! Look at all these hotels!",
      "✨ That's quite a collection you found!",
      "🌟 Popular search - let's narrow it down!"
    ]
  }
};

export const getRandomMessage = (category, subCategory = null) => {
  const messages = subCategory ? FUN_MESSAGES[category][subCategory] : FUN_MESSAGES[category];
  return messages[Math.floor(Math.random() * messages.length)];
}; 